import { weeklyPicks } from "@/mocks/gossip";
import { useState } from "react";

const categoryColors: Record<string, string> = {
  影视: "bg-primary-500/10 text-primary-700",
  综艺: "bg-accent-500/10 text-accent-700",
  音乐: "bg-secondary-500/15 text-secondary-800",
  生活: "bg-primary-500/10 text-primary-700",
  演出: "bg-accent-500/10 text-accent-700",
};

export default function WeeklyPicks() {
  const [copied, setCopied] = useState<number | null>(null);

  const handleShare = async (id: number, title: string) => {
    try {
      const text = `【每日瓜料】${title} —— 热门瓜一页看全`;
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      }
      setCopied(id);
      window.setTimeout(() => setCopied(null), 1800);
    } catch {
      setCopied(null);
    }
  };

  return (
    <section id="weekly" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <p className="text-xs font-medium uppercase tracking-widest text-accent-600">Weekly Wrap</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            本周必吃热门瓜
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            每周五集中归档的瓜田精选，错过任何一条都能在这里一站式补回。
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {weeklyPicks.map((pick) => {
            const color = categoryColors[pick.category] || "bg-secondary-500/15 text-secondary-800";
            return (
              <article
                key={pick.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={pick.img}
                    alt={`${pick.title} 专题配图`}
                    className="aspect-[3/2] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                    <i className="ri-fire-fill" aria-hidden="true"></i>
                    热度 {pick.heat.toFixed(1)}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-3 p-5">
                  <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className={`rounded-full px-2.5 py-1 font-medium ${color}`}>{pick.category}</span>
                    <span className="text-foreground-500">· {pick.date}</span>
                  </div>
                  <h3 className="text-base font-bold leading-snug text-foreground-950">
                    {pick.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{pick.excerpt}</p>
                  <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="rounded-full bg-secondary-500/15 px-2.5 py-1 text-xs font-medium text-secondary-700">
                      {pick.tag}
                    </span>
                    <button
                      type="button"
                      onClick={() => handleShare(pick.id, pick.title)}
                      className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700"
                    >
                      {copied === pick.id ? (
                        <>
                          <i className="ri-check-line" aria-hidden="true"></i> 已复制
                        </>
                      ) : (
                        <>
                          <i className="ri-share-forward-line" aria-hidden="true"></i> 分享这口瓜
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}